import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/ui/Sidebar';
import Icon from '../components/AppIcon';

const Settings = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'الإعدادات - Dawayer';
  }, []);

  const settingsItems = [
    {
      id: 1,
      title: 'تحليل أداء الفئات',
      description: 'عرض توزيع ومقاييس التفاعل لكل دائرة',
      icon: 'BarChart3',
      iconColor: 'var(--color-primary)',
      path: '/admin/settings/analytics'
    },
    {
      id: 2,
      title: 'إدارة المشرفين',
      description: 'إدارة الأدوار والصلاحيات',
      icon: 'Users',
      iconColor: 'var(--color-foreground)',
      path: '/admin/settings/admins'
    }
  ];

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-[#F9F7F2]" dir="rtl">
      <Sidebar />
      <main className="lg:mr-60 transition-default">
        <div className="p-6 lg:p-8">
          <h1 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-8">
            الإعدادات
          </h1>

          <div className="space-y-4 max-w-4xl">
            {settingsItems?.map((item, index) => (
              <React.Fragment key={item?.id}>
                <button
                  onClick={() => handleNavigate(item?.path)}
                  className="w-full bg-card rounded-xl p-6 shadow-warm hover:shadow-warm-md transition-default flex items-center justify-between group cursor-pointer border border-transparent hover:border-primary"
                >
                  <div className="flex items-center gap-4 flex-1">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-muted flex items-center justify-center group-hover:bg-primary group-hover:bg-opacity-10 transition-default">
                      <Icon 
                        name={item?.icon} 
                        size={24} 
                        color={item?.iconColor}
                        strokeWidth={2}
                      />
                    </div>
                    <div className="text-right flex-1">
                      <h3 className="text-lg font-heading font-semibold text-foreground mb-1 group-hover:text-primary transition-default">
                        {item?.title}
                      </h3>
                      <p className="text-sm font-body text-muted-foreground">
                        {item?.description}
                      </p>
                    </div>
                  </div>
                  <Icon 
                    name="ChevronLeft" 
                    size={20} 
                    color="var(--color-muted-foreground)"
                    className="flex-shrink-0 group-hover:text-primary transition-default"
                  />
                </button>
                {index < settingsItems?.length - 1 && (
                  <div className="h-px bg-primary bg-opacity-10 mx-4" />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Settings;